import { render } from "./YieldTrend.vue?vue&type=template&id=2cb5d471&scoped=true"
import script from "./YieldTrend.vue?vue&type=script&lang=js"
export * from "./YieldTrend.vue?vue&type=script&lang=js"

import "./YieldTrend.vue?vue&type=style&index=0&id=2cb5d471&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb5d471"]])

export default __exports__